// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1gxT9","delete":"styles_delete__3r7WX","update":"styles_update__1HKPq","add":"styles_add__28HE7"};